<template>
  <div class="et-branches-body">
    <div class="et-branches-content">
      <div class="et-branches-search">
        <span class="et-branches-search-label fl">地区：</span>
        <el-cascader class="et-router-search-label fl" size="mini" placeholder="请选择所在地区" :options="regionmodule.regions" v-model="search.BranchRegion" filterable></el-cascader>
        <span class="et-branches-search-label fl">地址：</span>
        <el-input size="mini" placeholder="请填写地址" v-model="search.Address" class="el-width-200 fl"></el-input>
        <span class="et-branches-search-label fl">企业名称：</span>
        <el-input size="mini" placeholder="请填写地址" v-model="search.EnterpriseName" class="el-width-200 fl"></el-input>
        <el-button size="mini" type="primary" icon="el-icon-search">查询</el-button>
        <div class="clear"></div>
      </div>
      <div class="et-branches-list">
        <div class="et-baidu-map fl" id="etmap"></div>
        <div class="et-branches-table fl">
          <ul>
            <li v-for="(item,index) in brancheslist" :key="index">
              <div>
                <router-link :to="{name:'enterprise',params:{enterpriseid:'0'}}" :tag="span" class="enterprise-label">{{item.EnterpriseName}}</router-link>
                <br />
                <span class="branches-label" @click="baiduMapLabelClick(item)">{{item.BranchesName}}</span><br />
                <span class="address-label" @click="baiduMapLabelClick(item)">{{regionmodule.regionEach(item.BranchesRegion,regionmodule.regions,0)+item.BranchesStreet+item.BranchesAddress}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import BMap from 'BMap'

export default {
  data () {
    return {
      keyword: '广州白云区',
      location: '广州',
      type: 'tab',
      address_detail: null,
      center: { lng: 113.290374, lat: 23.238916 },
      search: {
        BranchRegion: ['440000', '440100', '440111'],
        Address: '上胜创意园',
        EnterpriseName: ''
      },
      baiduMapDialog: {
        width: 300,
        height: 100,
        title: '',
        enableMessage: true
      },
      baiduMap: null,
      brancheslist: [
        {
          EnterpriseName: '广州凯捷物流供应链有限公司',
          BranchesName: '嘉禾营业部',
          BranchesRegion: ['440000', '440100', '440111'],
          BranchesRegionStr: '',
          BranchesStreet: '嘉禾街道',
          BranchesAddress: '上胜东街上胜创意园K栋101',
          baiduMarker: null
        },
        {
          EnterpriseName: '广州腾汇国际',
          BranchesName: '广州总部',
          BranchesRegion: ['440000', '440100', '440111'],
          BranchesRegionStr: '',
          BranchesStreet: '嘉禾街道',
          BranchesAddress: '上胜东街上胜创意园P栋103',
          baiduMarker: null
        },
        {
          EnterpriseName: '广州商盟国际',
          BranchesName: '广州总部',
          BranchesRegion: ['440000', '440100', '440111'],
          BranchesRegionStr: '',
          BranchesStreet: '嘉禾街道',
          BranchesAddress: '华联工业区喜聚创意园',
          baiduMarker: null
        },
        {
          EnterpriseName: '乐凯龙',
          BranchesName: '广州分公司',
          BranchesRegion: ['440000', '440100', '440111'],
          BranchesRegionStr: '',
          BranchesStreet: '嘉禾街道',
          BranchesAddress: '鹤龙一路金泰创意园C栋102',
          baiduMarker: null
        }
      ]
    }
  },
  mounted () {
    this.ready()
  },
  methods: {
    ready () {
      var map = new BMap.Map("etmap");
      map.centerAndZoom(new BMap.Point(this.center.lng, this.center.lat), 15);

      this.brancheslist.forEach((item, index) => {
        var content = this.regionmodule.regionEachTrim(item.BranchesRegion, this.regionmodule.regions, 0)
        var title = item.BranchesStreet + item.BranchesAddress
        var myGeo = new BMap.Geocoder()
        var self = this
        myGeo.getPoint(title, function (point) {
          if (point) {
            var marker = new BMap.Marker(point)
            map.addOverlay(marker)
            map.enableScrollWheelZoom(true) //允许鼠标缩放地图
            item.baiduMarker = marker
            marker.addEventListener('click', (e) => {
              self.baiduMapLabelClick(item)
            })
          }
        }, content)
      })
      this.baiduMap = map
    },
    baiduMapLabelClick (item) {
      var infoWindow = new BMap.InfoWindow(this.regionmodule.regionEachTrim(item.BranchesRegion, this.regionmodule.regions, 0) + item.BranchesStreet + item.BranchesAddress, { width: 300, height: 100, title: item.EnterpriseName + '-' + item.BranchesName, enableMessage: true })
      this.baiduMap.openInfoWindow(infoWindow, item.baiduMarker.point)
      this.baiduMap.setCenter(item.baiduMarker.point)
    }
  }
}

</script>

<style>
.et-branches-body .et-branches-list #etmap {
  width: 900px;
  height: 100%;
}

.et-branches-body {
  margin: 0 auto;
  padding: 0;
  width: 1280px;
}

.et-branches-body .et-branches-content {
  width: 100%;
  height: 800px;
  background-color: #ffffff;
  margin: 20px 0;
}
.et-branches-body .et-branches-search {
  padding: 20px 0;
  text-align: center;
  width: 850px;
  margin: 0 auto;
  height: 30px;
}

.et-branches-body .et-branches-search-label {
  padding-top: 5px;
}

.et-branches-body .et-branches-list {
  padding: 0 10px;
  height: 720px;
}

.et-branches-body .et-branches-table {
  width: 350px;
  height: 720px;
  overflow: auto;
  border: 1px solid #f2f2f2;
  line-height: 25px;
}
.et-branches-body .et-branches-table ul {
  margin: 0;
  padding: 0;
}

.et-branches-body .et-branches-table li {
  border-bottom: 1px solid #f2f2f2;
}

.et-branches-body .et-branches-table li.active {
  background-color: #dffcff;
}

.et-branches-body .et-branches-table li:hover {
  background-color: #dffcff;
}

.et-branches-body .et-branches-table div {
  padding: 0 10px;
}

.et-branches-body .branches-label {
  color: #1981c8;
  cursor: pointer;
}

.et-branches-body .address-label {
  color: #999999;
  font-size: 12px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/home/tmsbranches.vue